<template>
  <div class="pitem">
    <div class="pro_item">
      <div class="img" @click="productDetails">
        <img v-lazy="productItem.img_path" />
        <goods-tag
          :goods="productItem"
          :path="'addorder'"
          :dataObj="{ isprogift: isprogift }"
        ></goods-tag>
      </div>
      <div class="info" @click="productDetails">
        <div class="pro_tit">
          <div class="name">
            <label class="over-ell-1">{{ productItem.name }}</label>
            <img v-if="productItem.isoversea == 1" src="../../assets/images/overseas.png" />
          </div>
          <div class="num">
            X{{ productItem.num && !isNaN(productItem.num) ? productItem.num : 1 }}
          </div>
        </div>
        <div class="spec">{{ productItem.spec }}</div>
        <div class="spec giftactname" v-if="productItem.gift_act_name">
          赠品规则
          <img
            src="../../assets/images/integralrule.png"
            @click.stop="integralRule(productItem.gift_act_name)"
          />
        </div>
        <div class="price">
          <span
            class="xprice"
            v-if="!productItem.new_price && productItem.isdeposit && productItem.isdeposit == 1"
          >
            <sub>¥</sub>
            <b
              v-text="
                String(parseFloat(productItem.finalprice).toFixed(2)).slice(
                  0,
                  String(parseFloat(productItem.finalprice).toFixed(2)).indexOf('.')
                )
              "
            ></b>
            <sup
              v-text="
                String(parseFloat(productItem.finalprice).toFixed(2)).slice(
                  String(parseFloat(productItem.finalprice).toFixed(2)).indexOf('.'),
                  String(parseFloat(productItem.finalprice).toFixed(2)).length
                )
              "
            ></sup>
            <sub style="color: #fc0324">&nbsp;尾款¥</sub>
            <b
              style="color: #fc0324"
              v-text="
                String(parseFloat(productItem.finalpaymentmoney).toFixed(2)).slice(
                  0,
                  String(parseFloat(productItem.finalpaymentmoney).toFixed(2)).indexOf('.')
                )
              "
            ></b>
            <sup
              style="color: #fc0324"
              v-text="
                String(parseFloat(productItem.finalpaymentmoney).toFixed(2)).slice(
                  String(parseFloat(productItem.finalpaymentmoney).toFixed(2)).indexOf('.'),
                  String(parseFloat(productItem.finalpaymentmoney).toFixed(2)).length
                )
              "
            ></sup>
          </span>
          <span class="xprice" v-else-if="!productItem.new_price">
            <sub>¥</sub>
            <b
              v-text="
                String(parseFloat(productItem.price || '0.00').toFixed(2)).slice(
                  0,
                  String(parseFloat(productItem.price || '0.00').toFixed(2)).indexOf('.')
                )
              "
            ></b>
            <sup
              v-text="
                String(parseFloat(productItem.price || '0.00').toFixed(2)).slice(
                  String(parseFloat(productItem.price || '0.00').toFixed(2)).indexOf('.'),
                  String(parseFloat(productItem.price || '0.00').toFixed(2)).length
                )
              "
            ></sup>
          </span>
          <span class="xprice" v-else-if="productItem.new_price">
            <sub>¥</sub>
            <b
              v-text="
                String(parseFloat(productItem.new_price).toFixed(2)).slice(
                  0,
                  String(parseFloat(productItem.new_price).toFixed(2)).indexOf('.')
                )
              "
            ></b>
            <sup
              v-text="
                String(parseFloat(productItem.new_price).toFixed(2)).slice(
                  String(parseFloat(productItem.new_price).toFixed(2)).indexOf('.'),
                  String(parseFloat(productItem.new_price).toFixed(2)).length
                )
              "
            ></sup>
          </span>
          <!--isbuygift 前端自建参数-->
          <span
            class="openlist"
            v-if="
              (productItem.isgiftproduct == 1 || productItem.isbuygift == 1) && productItem.isgolist
            "
            @click="golist"
          >
            去选择
            <van-icon name="arrow" size="0.1rem" color="#1D1E1E" />
          </span>
          <span
            class="openlist red"
            v-if="
              !(productItem.isgiftproduct == 1 && productItem.isgolist) && productItem.integralnum
            "
          >
            送{{ productItem.integralnum }}金币
          </span>
          <span class="integral openlist red" v-if="productItem.integral">
            {{ productItem.price == '0.00' ? '' : '+'
            }}{{ productItem.integral > 0 ? productItem.integral + '金币' : '' }}
          </span>
        </div>
        <div
          class="f0 tag flex-ac flex-w"
          v-if="
            (productItem.taglist && productItem.taglist.length > 0) ||
            productItem.payfreight_tag == 1
          "
          style="margin-top: 0.04rem"
        >
          <van-tag
            v-if="productItem.payfreight_tag == 1"
            class="tag_danger"
            type="danger"
            style="margin-top: 0.03rem; margin-right: 0.05rem; line-height: normal"
          >
            不包邮
          </van-tag>
          <van-tag
            class="tag_danger"
            type="danger"
            style="margin-top: 0.03rem; margin-right: 0.05rem; line-height: normal"
            v-for="(item, index) of productItem.taglist || []"
            :key="index"
          >
            {{ item }}
          </van-tag>
        </div>
      </div>
    </div>
    <!--    <div class="ysale" v-if="productItem.ispresale == 1">-->
    <!--      <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>-->
    <!--      <img src="../../assets/images/presell.png"/>-->
    <!--      <div class="txt" v-if="productItem.presaletime">预售发货时间：{{productItem.presaletime}}</div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { encryption } from '../../assets/common/js/config'
import { Tag } from 'vant'
import goodsTag from '../common/goodsTag'
export default {
  name: 'cart_pro_item',
  props: {
    productItem: Object,
    default: {},
    isprogift: String
  },
  components: {
    [Tag.name]: Tag,
    goodsTag
  },
  methods: {
    productDetails() {
      if (this.$route.path == '/addOrderIntegral') {
      } else if (this.productItem.isprize && this.productItem.isprize == 1) {
      } else if (this.$route.query.np == 1) {
        this.$router.push({
          path: '/newprodetail'
        })
      } else if (this.$route.query.yl == 1) {
      } else if (this.$route.query.ms == 1) {
        // var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
        // this.$router.push({
        //   path: '/msproduct',
        //   query: {
        //     itemid: shopConfirmResult.limitid
        //   }
        // })
      } else if (this.$route.query.groupbuyid) {
      } else if (
        this.isprogift == 1 ||
        this.productItem.isgift == 1 ||
        this.productItem.isgiftproduct == 1 ||
        this.productItem.isbuygift == 1
      ) {
      } else {
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: this.productItem.itemid
          }
        })
      }
    },
    // 赠品规则
    integralRule: function (value) {
      if (!value) {
        return
      }
      this.$dialog
        .alert({
          title: '赠品规则',
          message: value,
          className: 'percen_button_alert integral_button_alert',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '我知道了',
          closeOnPopstate: false
        })
        .then(function () {
          // on confirm
        })
    },
    golist: function () {
      if (this.productItem.isgiftproduct == 1) {
        this.$router.replace({
          path: '/freeGiftZone',
          query: {
            path: encryption(this.$route.fullPath)
          }
        })
      } else if (this.productItem.isbuygift == 1) {
        this.$router.replace({
          path: '/freegiftzone_buygift',
          query: {
            path: encryption(this.$route.fullPath),
            itemid: this.productItem.itemid
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pitem {
  .pro_item {
    display: flex;
    padding-top: 0.1rem;
    align-items: center;
    .img {
      width: 0.8rem;
      height: 0.8rem;
      position: relative;
      flex-shrink: 0;
      img {
        &:first-of-type {
          width: 100%;
          height: 100%;
        }
      }
    }
    .info {
      margin-left: 0.07rem;
      position: relative;
      width: 73%;
      .pro_tit {
        font-size: 0.13rem;
        color: #292929;
        overflow: hidden;
        .name {
          font-size: 0.13rem;
          color: #292929;
          label {
            max-width: 80%;
            float: left;
            line-height: 0.18rem;
          }
          img {
            float: left;
            width: 0.18rem;
            height: 0.18rem;
            margin-left: 0.03rem;
          }
        }
        .num {
          float: right;
          color: #6c6c6c;
          font-size: 0.12rem;
          transform: scale(0.8);
          line-height: 0.2rem;
        }
      }
      .spec {
        font-size: 0.11rem;
        color: #6c6c6c;
        margin-top: 0.05rem;
      }
      .giftactname {
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        img {
          width: 0.16rem;
          height: 0.16rem;
          margin-left: 0.05rem;
        }
      }
      .price {
        font-size: 0.14rem;
        margin-top: 0.1rem;
        .xprice {
          font-size: 0;
        }
        .openlist {
          float: right;
          font-size: 0.12rem;
          color: #999999;
          &.red {
            color: #ffb346;
            float: initial;
          }
        }
        sub {
          font-weight: normal;
          font-size: 0.12rem;
          vertical-align: baseline;
        }
        b {
          font-size: 0.14rem;
          line-height: 0.2rem;
          font-weight: 500;
        }
        sup {
          font-size: 0.11rem;
          vertical-align: baseline;
          font-weight: 500;
        }
      }
    }
  }
  .ysale {
    margin-top: 0.08rem;
    display: flex;
    align-items: center;
    img {
      width: 0.12rem;
      margin-left: 0.04rem;
    }
    .txt {
      font-size: 0.12rem;
      color: #f12a0e;
      transform: scale(0.92, 0.92);
      margin-left: -0.03rem;
      line-height: 0.17rem;
    }
  }
}
.integral {
  color: #c58b53;
  font-size: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/cart_pro_item.vue